module.exports = __webpack_public_path__ + "static/eastwood-downloading-6c019659d7b9396cbac17dc896474896.svg";